module.exports = __webpack_public_path__ + "img/yishiyong.e57b7210.svg";